import React from 'react';
import GameScoreInfo from './GameScoreInfo';
import './GameScoreInfo.css';

/**
 * GameCardContent component displays the content of a game card
 * 
 * @param {Object} props - Component props
 * @param {string} props.username - Username of the player
 * @param {Object} props.userEntry - User entry in the leaderboard
 * @param {boolean} props.isRanked - Whether the player is ranked in this game
 * @param {Array} props.leaderboard - Array of player objects for the game
 */
function GameCardContent({ username, userEntry, isRanked, leaderboard = [] }) {
  const isUserRanked = isRanked && !!userEntry;
  const isGrandChampion = isUserRanked && userEntry.rank === 1;
  const showPoints = isUserRanked && !isGrandChampion && userEntry.points !== userEntry.rank;

  return (
    <>
      {isUserRanked && (
        <>
          {isGrandChampion && <p className="grand-champion-text">🏆 <strong>Grand Champion</strong></p>}
          {showPoints && <p><strong>Points:</strong> {userEntry.points}</p>}
        </>
      )}
      
      <p className="players-count"><strong>Players:</strong> {leaderboard.length}</p>
      
      {/* Display additional score information */}
      <GameScoreInfo 
        leaderboard={leaderboard}
        userEntry={isUserRanked ? userEntry : null}
        isRanked={isUserRanked}
      />
    </>
  );
}

export default GameCardContent;